<svelte:head>
  <title>{id || "Template"} | A Good Thing</title>
</svelte:head>
<!-- svelte-ignore a11y-label-has-associated-control -->
<!-- svelte-ignore a11y-missing-attribute -->

{#if data}
  <!-- Main container -->
  <nav class="level">
    <!-- Left side -->
    <div class="level-left level-can-wrap">
      <div class="level-item level-can-wrap">
        <h2 class="title">{id}</h2>
      </div>
    </div>

    <!-- Right side -->
    <div class="level-right"><button class="button">More actions</button></div>
  </nav>
  
  <!-- form -->
  
  <!-- apply? -->
  
  <!-- toast to show saved -->
  
  {#if showToast}
    <div class="notification is-success">
      <button class="delete" on:click={() => showToast = false} />
      Template updated
    </div>
  {/if}
  
  <div class="field is-horizontal">
    <div class="field-label is-normal"><label class="label">Subject</label></div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <input
            class="input"
            type="text"
            placeholder=""
            bind:value={data.subject} />
        </div>
      </div>
    </div>
  </div>
  
  <div class="field is-horizontal">
    <div class="field-label is-normal">
      <label class="label">Text</label>
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <textarea
            class="textarea"
            placeholder="10 lines of textarea"
            rows="10"
            bind:value={data.text} />
        </div>
      </div>
    </div>
  </div>
  
  <div class="field is-horizontal">
    <div class="field-label is-normal">
      <label class="label">HTML</label>
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <textarea
            class="textarea"
            placeholder="10 lines of textarea"
            rows="10"
            bind:value={data.html} />
        </div>
      </div>
    </div>
  </div>

  
  <div class="field is-horizontal">
    <div class="field-label">
      <!-- Left empty for spacing -->
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <button class="button is-primary" on:click={() => apply()}>Save</button>
        </div>
      </div>
    </div>
  </div>


{/if}

<script lang="ts">
  export let id :string;

  import _ from "lodash";
  
  let data :any;

  let showToast = false;
  
  let firebase = window.firebase;

  get();

  async function get() {
    firebase
      .firestore()
      .collection("_mail_templates")
      .doc(id)
      .onSnapshot((doc) => {
        data = doc.data();
      });
  }

  async function apply() {
    let firebase = window.firebase;

    await firebase.firestore().collection('_mail_templates').doc(id).update(data);

    showToast = true;
  }

</script>
